import { Input } from "@/components/ui/input";
import {
	InputSideLabel,
	InputSideLabelPopover,
} from "@/components/ui/InputSideLabel";
import {
	Popover,
	PopoverContent,
	PopoverTrigger,
} from "@/components/ui/popover";
import { cn } from "@/lib/utils";
import { t } from "i18next";
import type { ParameterInputProps } from "./types";
import { getInputClass } from "./utils";

export const ReductionInput = ({
	store,
	insurance,
	parameter,
}: ParameterInputProps<"reduction">) => {
	return (
		<div className="relative flex">
			<Input
				type="number"
				onWheel={(e) => (e.target as HTMLInputElement).blur()}
				value={parameter.value}
				onChange={(e) => {
					parameter.value = e.target.value;
					store.editParameter(insurance, parameter);
				}}
				className={cn("w-[110px] pr-12", getInputClass(parameter))}
			/>
			<Popover>
				<PopoverTrigger asChild>
					<InputSideLabel
						className={cn(
							"cursor-pointer",
							parameter.isAltered && "border-orange-400"
						)}
					>
						% A
					</InputSideLabel>
				</PopoverTrigger>
				<PopoverContent>
					<InputSideLabelPopover
						title={t("admin.insurances.parameters.type-to-name.reduction")}
						error={parameter.error}
						content={t("admin.insurances.parameters.content.reduction")}
						isAltered={parameter.isAltered}
						resetParam={() => store.resetParameter(insurance, parameter)}
					/>
				</PopoverContent>
			</Popover>
		</div>
	);
};

export const IncreaseInput = ({
	store,
	insurance,
	parameter,
}: ParameterInputProps<"increase">) => {
	return (
		<div className="relative flex">
			<Input
				type="number"
				onWheel={(e) => (e.target as HTMLInputElement).blur()}
				value={parameter.value}
				onChange={(e) => {
					parameter.value = e.target.value;
					store.editParameter(insurance, parameter);
				}}
				className={cn("w-[110px] pr-12", getInputClass(parameter))}
			/>
			<Popover>
				<PopoverTrigger asChild>
					<InputSideLabel
						className={cn(
							"cursor-pointer",
							parameter.isAltered && "border-orange-400"
						)}
					>
						% O
					</InputSideLabel>
				</PopoverTrigger>
				<PopoverContent>
					<InputSideLabelPopover
						title={t("admin.insurances.parameters.type-to-name.increase")}
						error={parameter.error}
						content={t("admin.insurances.parameters.content.increase")}
						isAltered={parameter.isAltered}
						resetParam={() => store.resetParameter(insurance, parameter)}
					/>
				</PopoverContent>
			</Popover>
		</div>
	);
};

export const IncreaseBefore34Input = ({
	store,
	insurance,
	parameter,
}: ParameterInputProps<"increase-before-34">) => {
	return (
		<div className="relative flex">
			<Input
				type="number"
				onWheel={(e) => (e.target as HTMLInputElement).blur()}
				value={parameter.value}
				onChange={(e) => {
					parameter.value = e.target.value;
					store.editParameter(insurance, parameter);
				}}
				className={cn("w-[120px] pr-12", getInputClass(parameter))}
			/>
			<Popover>
				<PopoverTrigger asChild>
					<InputSideLabel
						className={cn(
							"cursor-pointer",
							parameter.isAltered && "border-orange-400"
						)}
					>
						% O34
					</InputSideLabel>
				</PopoverTrigger>
				<PopoverContent>
					<InputSideLabelPopover
						title={t(
							"admin.insurances.parameters.type-to-name.increase-before-34"
						)}
						error={parameter.error}
						content={t(
							"admin.insurances.parameters.content.increase-before-34"
						)}
						isAltered={parameter.isAltered}
						resetParam={() => store.resetParameter(insurance, parameter)}
					/>
				</PopoverContent>
			</Popover>
		</div>
	);
};

export const ReductionInGInput = ({
	store,
	insurance,
	parameter,
}: ParameterInputProps<"reduction-in-g">) => {
	return (
		<div className="relative flex">
			<Input
				type="number"
				onWheel={(e) => (e.target as HTMLInputElement).blur()}
				value={parameter.value}
				onChange={(e) => {
					parameter.value = e.target.value;
					store.editParameter(insurance, parameter);
				}}
				className={cn("w-[115px] pr-12", getInputClass(parameter))}
			/>
			<Popover>
				<PopoverTrigger asChild>
					<InputSideLabel
						className={cn(
							"cursor-pointer",
							parameter.isAltered && "border-orange-400"
						)}
					>
						G O
					</InputSideLabel>
				</PopoverTrigger>
				<PopoverContent>
					<InputSideLabelPopover
						title={t("admin.insurances.parameters.type-to-name.reduction-in-g")}
						content={t("admin.insurances.parameters.content.reduction-in-g")}
						error={parameter.error}
						isAltered={parameter.isAltered}
						resetParam={() => store.resetParameter(insurance, parameter)}
					/>
				</PopoverContent>
			</Popover>
		</div>
	);
};
